import $ = require('jquery');
import Modul from './Modul';

/**
 * Rss module class
 */

export default class ModulRss extends Modul {
    constructor(moduleId: number) {
        super(moduleId);
        $("#h1_" + this.moduleId).diy_radiobox();
        $("#h2_" + this.moduleId).diy_radiobox();
        $("#b1_" + this.moduleId).diy_radiobox();
        $("#b2_" + this.moduleId).diy_radiobox();
        $("#d1_" + this.moduleId).diy_radiobox();
        $("#d2_" + this.moduleId).diy_radiobox();
        $("#v1_" + this.moduleId).diy_radiobox();
        $("#v2_" + this.moduleId).diy_radiobox();

    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulRss.ts
 **/